import script from "./ClickIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClickIcon.vue?vue&type=script&lang=ts&setup=true"

import "./ClickIcon.vue?vue&type=style&index=0&id=89b6a662&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89b6a662"]])

export default __exports__